/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LinkedContactsCard_linkedContactRoles = {
    readonly nodes: ReadonlyArray<{
        readonly role: string;
        readonly contactLink: {
            readonly displayRole: string;
            readonly displayName: string;
            readonly contactItem: {
                readonly slug: string;
                readonly title: string;
                readonly image: {
                    readonly url: string | null;
                    readonly alt: string | null;
                } | null;
            };
        } | null;
    } | null> | null;
    readonly " $refType": "LinkedContactsCard_linkedContactRoles";
};
export type LinkedContactsCard_linkedContactRoles$data = LinkedContactsCard_linkedContactRoles;
export type LinkedContactsCard_linkedContactRoles$key = {
    readonly " $data"?: LinkedContactsCard_linkedContactRoles$data;
    readonly " $fragmentRefs": FragmentRefs<"LinkedContactsCard_linkedContactRoles">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkedContactsCard_linkedContactRoles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContactLinkRole",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContactLink",
          "kind": "LinkedField",
          "name": "contactLink",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayRole",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ListItem",
              "kind": "LinkedField",
              "name": "contactItem",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Image",
                  "kind": "LinkedField",
                  "name": "image",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "alt",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContactLinkRoleConnection",
  "abstractKey": null
};
(node as any).hash = 'd1efeb95c68dbc9fb93c5f701be9ae63';
export default node;
